<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col md="12">
          <h5 class="section-label mb-3">
            {{ $t('End Of The Year Posting') }}
          </h5>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <validation-observer ref="endOfYearRules">
            <b-form>
              <b-row class="match-height">

                <b-col md="12">
                  <DatePickerField
                    id="financial-year-end"
                    v-model="endOfYearData.financialDate"
                    rules="required"
                    :label="$t('Financial Year End')"
                    :error-name="$t('Financial Year End')"
                    :config="finacialYearEndConfig"
                    :disabled="isReadonly"
                  />
                </b-col>

                <!-- Vault Account -->
                <b-col
                  md="12"
                >
                  <SelectField
                    id="general-revserve-account"
                    v-model="endOfYearData.generalReserveAccount"
                    :label="$t('General Reserve Account')"
                    :options="generalReserveAccountOptions"
                    :placeholder="$t('Select')"
                    :reduce="option => option.value"
                    rules="required"
                    :error-name="$t('General Reserve Account')"
                    item="label"
                    :readonly="isReadonly"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <Button
                    v-if="getUserPermission('END_OF_YEAR_POSTING')"
                    :label="$t('Run End Of Year')"
                    size="md"
                    class="mt-0"
                    :loading="isLoading"
                    :disabled="isDisabled"
                    @click="handleSubmit"
                  />
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </div>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BForm,
} from 'bootstrap-vue'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions, mapGetters } from 'vuex'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toDateWithYear, toYearWithDate } from '../../../../helpers/formatDate'
import SelectField from '../../../forms/SelectField.vue'
import DatePickerField from '../../../forms/DatePickerField.vue'
import Button from '../../../components/button/Button.vue'
import { postingPermissions } from '../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    Button,
    BForm,
    ValidationObserver,
    SelectField,
    DatePickerField,
    FullScreenSpinner,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isBusy: true,
      showSpinner: false,
      isLoading: false,
      isDisabled: false,
      sBusy: false,
      toDateWithYear,
      required,
      positive,
      endOfYearClosureList: [],
      endOfYearData: {
        financialDate: null,
        generalReserveAccount: '',
      },
      finacialYearEndConfig: {
        dateFormat: 'd/m/Y',
        defaultDate: '',
      },
      generalReserveAccountOptions: [],
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
    }),
  },

  async mounted() {
    this.fetchGeneralLedgerByProductCategory()
  },
  methods: {
    ...mapActions({
      postEndOfYearClosure: 'posting/postEndOfYearClosureAction',
      getGLAccountsByAccountType: 'account/getGLAccountsByAccountTypeList',
      getGeneralLedgerByParentCategory: 'account/getGeneralLedgerByParentCategory',
    }),

    handleSubmit() {
      this.$refs.endOfYearRules.validate().then(success => {
        const text1 = this.$t('You are about to run End of Year Closure for')
        const text2 = this.$t('Please be aware that this action cannot be reversed! Are you sure?')
        if (success) {
          this.confirm(this.performEndOfYear, { text: `${text1} ${this.endOfYearData.financialDate}. ${text2}` })
        }
      })
    },
    async performEndOfYear() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const postingData = {
          financialDate: this.endOfYearData.financialDate ? toYearWithDate(this.endOfYearData.financialDate) : null,
          generalReserveAccount: this.endOfYearData.generalReserveAccount.toString(),
          initiatedBy: this.userData.email,
          approvedBy: '',
        }
        const response = await this.postEndOfYearClosure({ postingData, permission: postingPermissions.END_OF_YEAR_POSTING })
        const { status, data } = response
        if (status === 200 && data.isSuccessful) {
          this.hideModal('modal-lg')
          this.alertSuccess({ text: data.message })
        }
        if (status === 200 && !data.isSuccessful) {
          this.hideModal('modal-lg')
          this.alertError({ text: data.message })
        }
        this.isLoading = false
        this.isDisabled = false
        this.endOfYearData = {
          financialDate: null,
          generalReserveAccount: '',
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    async fetchGeneralLedgerByProductCategory() {
      try {
        const response = await this.getGeneralLedgerByParentCategory({
          parentCategory: 3,
          permission: postingPermissions.END_OF_YEAR_POSTING,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.generalReserveAccountOptions = data.data.filter(item => item.status === 'Active').reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code }], [])
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
  },
}
</script>
